export default class {
    constructor() {

    }
}